module.exports = __webpack_public_path__ + "assets/src/style/img/svg/icons/category-my-list.svg?6e3628613ab236f532a4d605df6f0e17";